import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import LandingPage from "./routes/LandingPage";
import YearGroupSetup from "./routes/YearGroupSetup";
import AcademicYearSetup from "./routes/AcademicYearSetup";
import RosteringPlatformSetup from "./routes/RosteringPlatformSetup";
export default store => {
  return {
    path: "academic-year-transition",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(
            /* webpackChunkName: "academic-year-transition" */ "./components"
          ),
          import(
            /* webpackChunkName: "academic-year-transition" */ "./modules/AcademicYearTransitionModules"
          ),
        ]).then(([importedModule0, importedModule1]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          injectReducer(store, {
            key: "academicYearTransitionBasicSetup",
            reducer,
          });
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      LandingPage(store),
      YearGroupSetup(store),
      AcademicYearSetup(store),
      RosteringPlatformSetup(store),
    ],
  };
};
